import React from 'react';
import { Grid, Button, Checkbox } from '@material-ui/core';

// TODO // replace hard coded TJ with airline
export const FlightItem = (props) => {
  let flight = props.flight
  let index = props.index
  let remove = props.remove

  return (
    <div style={{border: '1px solid gray', borderRadius: '5px', backgroundColor: '#c5c5c5'}}>
      <Grid container item xs={12}>
        <Grid item xs={1}></Grid>
        <Grid container alignContent="center" item xs={9}>
          TJ{flight}
        </Grid>
        <Grid container item xs={2}>
          <Button style={{color: 'red'}} onClick={() => {remove(index)}}>X</Button>
        </Grid>
      </Grid>
    </div>
  )
}

export const RadioDOTW = (props) => {
  let day = props.day
  let handleChange = props.change

  return (
    <div style={{width: '14%'}}>
      <p>{day.day}</p>
      <Checkbox
        checked={day.checked}
        onChange={(e) => {handleChange(e.target.value)}}
        value={day.day}
        name="radio-buttons"
        inputProps={{ 'aria-label': `${day.day}` }}
      />
    </div>
  )
}

export const StatusDisplay = (props) => {
  const status = props.status
  console.log(status);
  if (status === null) {
    return (
      <div>Status: Loading...</div>
    )
  }
  else if (status === true) {
    return (
      <div>Status: <span style={{color: 'green'}}>Success!</span></div>
    )
  }
  else if (status === false) {
    if(props.response)
    {
      let{result,avsresult}=props.response;
      const statusColor = result.match('ERROR') ? 'red' : 'green';
      const avsResultColor = ((avsresult !== null && avsresult.match('ERROR'))) ? 'red' : 'green';
      return (
        <div>Status: <span style={{color: 'red'}}>Failure</span><br/>
  IMN Status: <span style={{ color: statusColor }}>{result}</span> <br />
  {avsresult !== null && ( // Conditionally render AVS Result only if it's not null
        <>
          AVS Status: <span style={{ color: avsResultColor }}>{avsresult}</span> <br />
        </>
      )}      </div>)
    }
    return (
      <div>Status: <span style={{color: 'red'}}>Failure</span>
          </div>
    )
  }

  return (
    <div></div>
  )
}